import { inject } from 'aurelia-framework';
import { HttpClient } from 'aurelia-http-client';

@inject(HttpClient)
export class VideoCaptureLogAdminAPI {

    constructor(http) {
        this.http = http;
    }


    getList(testimonial_type, testimonial_id, page, limit, sortBy, sortDir, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);
    
        });

        var queryString = "?page=" + page;
        queryString += "&limit=" + limit;
        queryString += "&sortBy=" + sortBy;
        queryString += "&sortDir=" + sortDir;

        this.http.get('api/admin/videoCaptureLog/getList' + (testimonial_id == null || testimonial_type == null ? "" : "/" + testimonial_type + "/" + testimonial_id) + queryString)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("log"))
                        successCallback(json.log);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);
                    
                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

}